import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import ShowDetails from "../ShowDetails/ShowDetails";

const SearchTable = ({
  firstItem,
  endItem,
  filter,
  setFilter,
  onSearch,
  showDetails,
  setShowDetails,
  filterPlaceholder,
}) => {
  const { pathname } = useLocation();

  const [isSearch, setIsSearch] = useState(false);

  useEffect(() => {
    setIsSearch(false);
  }, [pathname]);

  return (
    <div className="card-inner position-relative card-tools-toggle">
      <div className="card-title-group">
        <div className="card-tools mr-n1 justify-content-between align-items-center d-flex w-100">
          <ul className="btn-toolbar gx-1">
            {firstItem && <li className="nk-block-tools-opt">{firstItem}</li>}
            {setFilter && onSearch && (
              <>
                {firstItem && <li className="btn-toolbar-sep" />}
                <li className="nk-block-tools-opt">
                  <button
                    onClick={() => setIsSearch(true)}
                    className="btn btn-icon search-toggle toggle-search"
                  >
                    <Icon name="search" />
                  </button>
                </li>
              </>
            )}
            {setShowDetails && (
              <>
                {(firstItem || setFilter) && <li className="btn-toolbar-sep" />}
                <li className="nk-block-tools-opt">
                  <ShowDetails
                    showDetails={showDetails}
                    setShowDetails={setShowDetails}
                  />
                </li>
              </>
            )}
          </ul>
        </div>
        {endItem && endItem}
      </div>
      <div className={`card-search search-wrap ${isSearch && "active"}`}>
        <div className="card-body">
          <form onSubmit={onSearch} className="search-content">
            <Button
              className="search-back btn-icon toggle-search active"
              onClick={() => {
                setIsSearch(false);
                setFilter("");
              }}
              type="button"
            >
              <Icon name="arrow-right" />
            </Button>
            <input
              type="text"
              className="border-transparent form-focus-none form-control"
              placeholder={filterPlaceholder}
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
            <Button type="submit" className="search-submit btn-icon">
              <Icon name="search" />
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SearchTable;
